module.exports = "/_next/static/images/profile-mar-37bd60142b5f24e2ac1eb476a7bd183e.png";